export default "__VITE_ASSET__b7283178__"